import { useEffect, useState } from "react";

const FIGMA_HEIGHT = 832;
const FIGMA_WIDTH = 1280;

const DAMS_SIDE_DRAWER_WIDTH = 312;
const DAMS_PAGE_TOP_BAR_HEIGHT = 130;


const UseWindowDimensions = () => {
    const [windowDimensions, setWindowDimensions] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    useEffect(() => {
        const handleResize = () => {
            setWindowDimensions({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
};

function toTitleCase(str : string) {
    return str.replace(/\w\S*/g, (txt) => {
        return txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase();
    });
}

const windowHeight = window.innerHeight;
const windowWidth = window.innerWidth;
// const windowWidth = UseWindowDimensions().width;
// const windowHeight = UseWindowDimensions().height;



const getFigmaHeight = (height?: number | string) => {
    if (!height) {
        return '0px';
    }
    if (typeof height === 'string') {
        height = parseInt(height.replace(/\D/g, ''), 10);
    }
    return `${(height / FIGMA_HEIGHT) * window.innerHeight}px`;
};

const getFigmaHeightPercent = (height?: number | string) => {
    if (!height) {
        return '0px';
    }
    if (typeof height === 'string') {
        height = parseInt(height.replace(/\D/g, ''), 10);
    }
    return `${(height / FIGMA_HEIGHT) * 100}%`;
}

const getFigmaWidth = (width?: number | string) => {
    if (!width) {
        return '0px';
    }
    if (typeof width === 'string') {
        width = parseInt(width.replace(/\D/g, ''), 10);
    }
    return `${(width / FIGMA_WIDTH) * window.innerWidth}px`;
};

const getFigmaWidthPercent = (width?: number | string) => {
    if (!width) {
        return '0px';
    }
    if (typeof width === 'string') {
        width = parseInt(width.replace(/\D/g, ''), 10);
    }
    return `${(width / FIGMA_WIDTH) * 100}%`;
}


export {
    UseWindowDimensions,
    getFigmaHeight,
    getFigmaWidth,
    getFigmaHeightPercent,
    getFigmaWidthPercent,

    DAMS_PAGE_TOP_BAR_HEIGHT,
    DAMS_SIDE_DRAWER_WIDTH,
    toTitleCase
};
